import { HttpMethod, Performer } from '../core'

export class GameClaim extends Performer<
  {
    payload: {
      level: number
    }
  },
  {
    points: number
  }
> {
  protected method = HttpMethod.POST
  protected url = '/game-claim'
}
